import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import mensCategoryPicture from '../../assets/img/mens-fashion.jpeg';
import womensCategoryPicture from '../../assets/img/womens-fashion.jpg';
import electronicsCategoryPicture from '../../assets/img/electronics.jpeg';
import jewelleryCategoryPicture from '../../assets/img/jewellery.jpeg';

import CategoryCard from '../../Components/CategoryCard/CategoryCard';
import styles from './Home.module.scss';

const Home: FC = () => (
  <div className={styles.homeContainer}>
    <div className={styles.backgroundImage} />
    <div className={styles.hero}>
      <div className={styles.titleContainer}>
        <div className={styles.heading}>Online Flee Market for Clothes</div>
        <div className={styles.subHeadingContainer}>
          <div className={styles.horizontalLine} />
          <div className={styles.subHeading}>It&lsquo;s time to recycle</div>
          <div className={styles.horizontalLine} />
        </div>
      </div>
    </div>

    <div className={styles.heading}>
      <h1>Most in Demand</h1>
    </div>
    <div className={styles.categoryContainer}>
      <div className={styles.left}>
        <Link to="/product-list/men clothing">
          <CategoryCard horizontal imageUrl={mensCategoryPicture} title="Men Clothing" />
        </Link>
        <Link to="/product-list/women clothing">
          <CategoryCard horizontal imageUrl={womensCategoryPicture} title="Women clothing" />
        </Link>
      </div>
      <div className={styles.right}>
        <Link to="/product-list/electronics">
          <CategoryCard horizontal={false} imageUrl={electronicsCategoryPicture} title="Electronics" />
        </Link>
        <Link to="/product-list/jewelery">
          <CategoryCard horizontal={false} imageUrl={jewelleryCategoryPicture} title="Jewelery" />
        </Link>
      </div>
    </div>

  </div>
);

export default Home;
